import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


export default function Footer() {
    const [isMobile, setIsMobile] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const checkSize = () => setIsMobile(window.innerWidth < 768);
        checkSize();
        window.addEventListener("resize", checkSize);
        return () => window.removeEventListener("resize", checkSize);
    }, []);

    return (
        <footer
            style={{
                width: "100%",
                backgroundColor: "#003c81",
                color: "white",
                padding: "40px 20px 20px 20px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div
                style={{
                    width: "100%",
                    maxWidth: "1400px",
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row",
                    justifyContent: "space-between",
                    alignItems: isMobile ? "center" : "flex-start",
                    gap: isMobile ? "30px" : "40px",
                }}
            >
                {/* COLUNA 1 */}
                <div
                    style={{
                        width: isMobile ? "100%" : "30%",
                        textAlign: isMobile ? "center" : "left",
                    }}
                >
                    <h2 style={{ fontSize: "24px", marginBottom: "10px" }}>FiscalTec</h2>
                    <p style={{ lineHeight: "1.6", fontSize: "16px", opacity: 0.8 }}>
                        Soluções tecnológicas e inteligência fiscal para simplificar e
                        otimizar sua gestão tributária.
                    </p>
                </div>

                {/* COLUNA 2 */}
                <div
                    style={{
                        width: isMobile ? "100%" : "30%",
                        textAlign: isMobile ? "center" : "left",
                    }}
                >
                    <h3 style={{ fontSize: "20px", marginBottom: "10px" }}>Links Úteis</h3>
                    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                        <li style={{ marginBottom: "8px", cursor: "pointer" }} onClick={() => navigate("../")}>Início</li>
                        <li style={{ marginBottom: "8px", cursor: "pointer" }} onClick={() => navigate("../SobreNos")}>Sobre Nós</li>
                        <li style={{ marginBottom: "8px", cursor: "pointer" }} onClick={() => navigate("../SolucoesEmEvidencia")}>Soluções</li>
                        <li style={{ marginBottom: "8px", cursor: "pointer" }} onClick={() => navigate("../Socios")}>Sócios</li>
                    </ul>
                </div>

                {/* COLUNA 3 */}
                <div
                    style={{
                        width: isMobile ? "100%" : "30%",
                        textAlign: isMobile ? "center" : "left",
                    }}
                >
                    <h3 style={{ fontSize: "20px", marginBottom: "10px" }}>Contato</h3>

                    <p style={{ marginBottom: "8px", lineHeight: "1.4" }}>
                        📍 Avenida Senador Souza Naves 73, Curitiba - PR
                    </p>

                    <p style={{ marginBottom: "8px" }}>📞 (41) 3121-2758</p>

                    <p style={{ marginBottom: "8px" }}>📧 fiscaltec@fiscaltec.com</p>
                </div>
            </div>

            {/* COPYRIGHT */}
            <div
                style={{
                    width: "100%",
                    textAlign: "center",
                    marginTop: "40px",
                    borderTop: "1px solid rgba(255,255,255,0.2)",
                    paddingTop: "15px",
                }}
            >
                <p style={{ fontSize: "14px", opacity: 0.8 }}>
                    © 2026 FiscalTec Todos os direitos reservados. 
                </p>
            </div>
        </footer>
    );
}
